import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { Webhook } from '../webhooks.models';
import { RootState } from 'app/store';
import { PURGE } from 'redux-persist';

interface WebhooksTableState {
  webhookToBeDeleted?: Webhook;
}

const initialState: WebhooksTableState = {};

const webhooksTableSlice = createSlice({
  name: 'webhooksTable',
  initialState,
  reducers: {
    onWebhookToBeDeletedChanged: (
      state,
      action: PayloadAction<Webhook | undefined>
    ) => {
      state.webhookToBeDeleted = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

const { actions, reducer } = webhooksTableSlice;

export const { onWebhookToBeDeletedChanged } = actions;

const selectSelf = (state: RootState) => state.webhooksTable;

export const selectWebhookToBeDeleted = createSelector(
  selectSelf,
  (state) => state.webhookToBeDeleted
);

export default reducer;
